// Bridge so code outside the React tree (the axios request interceptor) can
// get a live Auth0 access token without the app keeping its own duplicate,
// unscoped copy in localStorage - getAccessTokenSilently() already reads
// from Auth0's own (namespaced) token cache, refreshing only when needed.

export type TokenGetter = () => Promise<string | undefined>;

let tokenGetter: TokenGetter | null = null;

export const setTokenGetter = (getter: TokenGetter | null) => {
  tokenGetter = getter;
};

export const getAccessToken = (): Promise<string | undefined> => {
  return tokenGetter ? tokenGetter() : Promise.resolve(undefined);
};
